import {Component, Input, OnInit} from "@angular/core";
import {LookupService} from "../../lookup.service";
import {DataEntry, FieldData} from "../../../../model/fields.model";

@Component({
  selector: "admin-lookup-common-entry",
  templateUrl: "./entry.component.html",
  styleUrls: ["./entry.component.css"]
})
export class AdminLookupCommonEntryComponent implements OnInit {

  private entry: DataEntry
  private fields: Map<string, FieldData>

  constructor(
    private singleService: LookupService,
  ) {
    this.fields = new Map<string, FieldData>()
  }

  ngOnInit(): void {
    this.singleService.entry
        .subscribe((entry) => {
          this.entry = entry;
          this.entry.data.forEach(value => {
            let key = value.config?.name ?? ""
            if (key != "") {
              this.fields.set(key, value);
            }
          });
        });
  }

  getEntry() {
    return this.entry;
  }

  getField(name: string) {
    return this.fields.get(name);
  }

}
